<div id="card">
  <div class="card-content">
    <div class="title-block pulsate"></div>
    <div class="progress-block pulsate"></div>
    <div class="subtitle-block pulsate"></div>
  </div>
</div>
